<template>
    <div
        v-if="breadcrumb"
        class="d-flex py-2 justify-content-center"
        :class="layout ? 'fixed-header' : ''"
        :style="`backgroundColor: ${color.primary}`"
    >
        <div class="col-lg-6 col-7 d-flex align-items-center container left">
            <!-- <div
                v-if="backButton"
                @click="goBack"
                class="h2 text-white d-inline-block mb-0 cursor-pointer nch--cursor-pointer">
                <i class="fa-2x far fa-arrow-alt-circle-left"></i>
            </div>-->
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                    <li class="breadcrumb-item">
                        <a href="/app/dashboard" :style="{'color': color.secondary}">
                            <i class="fas fa-home"></i>
                        </a>
                    </li>
                    <li v-for="(item, i) in breadcrumbList" :key="i" class="breadcrumb-item">
                        <span
                            v-if="item.disabled"
                            :style="{'color': color.secondary}"
                            :class="lastItem(i)"
                        >{{$t(item.text)}}</span>
                        <a
                            v-else
                            :style="{'color': color.secondary}"
                            :href="item.href"
                        >{{$t(item.text)}}</a>
                    </li>
                </ol>
            </nav>
        </div>
        <div class="col-lg-6 col-5">
            <!-- space for future implementations -->
        </div>
    </div>
</template>

<script>
export default {
    name: "Breadcrumb",
    props: {
        breadcrumb: {
            type: String | Boolean
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        breadcrumbList() {
            let list = JSON.parse(this.breadcrumb);
            return list;
        },
        layout() {
            return this.$store.getters.NAVBAR_FIXED;
        }
    },
    methods: {
        lastItem(index) {
            let lastItemIndex = this.breadcrumbList.indexOf(
                this.breadcrumbList[this.breadcrumbList.length - 1]
            );
            if (index === lastItemIndex) return "text-disabled";
        }
    }
};
</script>

<style>
.text-disabled {
    opacity: 65%;
}
.fixed-header {
    position: fixed;
    width: 100%;
    top: 95px;
    z-index: 999;
}
</style>
<style scoped>
.left{
    left: calc(50vw - 570px);
}
</style>
